import * as React from 'react';
import * as _ from 'lodash';
import { getEnginePerPackage } from 'common/utils';
import { Header, InfoHeader, Title } from '../../common/baseComponents';
import { PageTitleContainer, PageTitleText } from '../../common/baseComponents';
import { Route, useLocation, useHistory, useParams } from 'react-router';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { HomeBody, HomeContainer, HeaderContainer, ActionSection, RotateIcon,ToolTipArea, ContactButton, SearchContainer, Content, ContentCol, Scroll, HeaderIconContainer } from './styles';
import DealerDetail from 'features/Dealers';
import DealerSelect from '../Dealers/DealerSelect';
import ButtonTooltip from 'components/ButtonTooltip';
import { RootState } from 'store/types';
import ModalStop from './Modals/ModalStop'
import ModalStart from './Modals/ModalStart'
import TooltTip from 'components/ToolTip'
import { ToolTipDirection } from 'components/ToolTip'
import ModalUpsellUpgrade from './Modals/UpsellUpgrade'
import ModalUpsellUpgradePackage from './Modals/UpsellUpgradePackage'
import ModalUpsellSetup from './Modals/UpsellSetup'
import ModalPush from 'features/Dealers/DealerConfiguration/Modals/ModalPush'
import { publishAPI,publishCleanResult } from 'features/Dealers/DealerConfiguration/Modals/ModalPush/state/actions';
import { PUBLISH_API_REQUEST } from 'features/Dealers/DealerConfiguration/Modals/ModalPush/state/actionTypes';
import { getLastSyncDateAPI, syncEngineDealerAPI, unsyncEngineDealerAPI } from '../Dealers/state/actions';
import { POST_DEALER_CACHE_SYNC_API_REQUEST } from 'features/Dealers/DealerConfiguration/state/actionTypes';
import { DatesFromToMainContainer, DatesContainer, FromToToolTipContainer, DatesLastSyncText, DatesLastSyncContainer, DatesFromToText, DatesFromToContainer, DatesInfoIconContainer, DatesCalendarIconContainer, DatesToolTipContainer, DatesToolTipText } from './styles';
import InfoIcon from 'common/icons/infoIcon';
import { serviceLoading } from 'common/loaderReducer';
import { GET_USER_SETTING_API_REQUEST } from 'features/Dealers/Performance/state/actionTypes';
import { GET_LASTSYNCDATE_API_REQUEST, UNSYNC_DEALER_API_REQUEST } from 'features/Dealers/state/actionTypes';
import { ReactComponent as DealeronIcon } from 'common/images/dealeron-logo.svg'
import { ReactComponent as LeadScienceIcon } from 'common/images/lead-science-logo.svg'
import { role1, role2, role3 } from './constants'
import { blurAppRequest } from 'features/Security/state/actions'
import SideBar from 'features/SideBar';
import Calendar from 'features/Dealers/Performance/Calendar'
import ActionButtons from 'features/Dealers/Reviews/ActionButtons'
import { SYNC_DEALER_API_REQUEST } from 'features/Dealers/state/actionTypes';
import { getShowHeader } from '../Dealers/AdvancedLm/state/selector';

import {
    InfoContainer,
    ContainerTitle,
    InfoBodyContainer,
    ToolTipContainer,
    ToolTipText,
    HoursContainer, HourContainer, DayContainer, Day2Container
} from 'features/Dealers/Listings/Info/styles';
import SettingsPanel from 'features/SettingsPanel';
import { openSettingsPanelAction } from 'features/SettingsPanel/state/actions';
import { getOpenSettingsPanel } from 'features/SettingsPanel/state/selectors';
import ModalStartElite from 'features/Home/Modals/ModalStartElite';
import { ListingType } from 'features/Dealers/Listings/state/types';
import { changeDocumentHead, DEFAULT_WEBSITE_PROVIDER } from './utils';

const TITLES: { [x: string]: string } = {
    ["/dealer/activity"]: "Google Performance",
    ["/dealer/primary"]: "Primary Location",
    ["/dealer/connect"]: "Configuration - Connect",
    ["/dealer/departments/edit"]: "Departments",    
    ["/dealer/advanced"]: "Advanced Listings Management", 
    ["/dealer/reviews"]: "Reviews Widgets",    
}
const VALID_PATHS: string[] = [
    "/dealer/activity",
    "/dealer/primary",
    "/dealer/connect",
    "/dealer/departments/edit",    
    "/dealer/department/",
    "/dealer/advanced",
    "/dealer/reviews"
]

export interface HomeProps {
}

const Home = (props: HomeProps) => {
    const [showStopModal, setShowStopModal] = React.useState(false);
    const [showStartModal, setShowStartModal] = React.useState(false);
    const [showStartEliteModal, setShowStartEliteModal] = React.useState(false);
    const [showSyncModal, setShowSyncModal] = React.useState(false);
    const [showUpsellUpgrade, setShowUpsellUpgrade] = React.useState(false);
    const [showUpsellSetup, setShowUpsellSetup] = React.useState(false);
    const [showUpsellUpgradePackage, setShowUpsellUpgradePackage] = React.useState(false);
    const [isSynced, setIsSynced] = React.useState(false);
    const [collapse, setCollapse] = React.useState<boolean>(true);
    const [hideSearch, setHideSearch] = React.useState<boolean>(false);
    const [triggerPublish, setTriggerPublish] = React.useState<boolean>(false);
    const [isSyncingOrPublishing, setIsSyncingOrPublishing] = React.useState<boolean>(false);
    const [hideModals, setHideModals]= React.useState(false);

    const [syncType, setSyncType]= React.useState<string|undefined>(undefined)

    const openSettingsPanel = useSelector(getOpenSettingsPanel);
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();
    const params = useParams();
    const anvancedSepUp = React.useRef(false);

    const showHeader = useSelector(getShowHeader);
    React.useEffect(() => {
        if (showSyncModal) {
            dispatch(publishCleanResult());
        }
    }, [showSyncModal]);

    const {
        webSiteProvider,
        selectedDealer,
        isCacheSyncing,
        isPublishSyncing,         
        isStopSyncing,       
        publishSyncResult,        
        listingsByDealerId,
        liveDepartments,
        user,
        departments,
        engineDealer, 
        isSyncingDealer,       
        listingsChanges,
    } = useSelector((rootState: RootState) => {
        return {
            webSiteProvider: rootState.dealers.dealer.websiteProvider,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            isCacheSyncing: serviceLoading(rootState, [POST_DEALER_CACHE_SYNC_API_REQUEST]),
            isPublishSyncing: serviceLoading(rootState, [PUBLISH_API_REQUEST]),            
            isStopSyncing: serviceLoading(rootState, [UNSYNC_DEALER_API_REQUEST]),            
            publishSyncResult: rootState.dealers.modelSync.publishResult,
            listingsByDealerId: rootState.dealers.listing.listings.byDealerId,
            liveDepartments: rootState.dealers.departments.liveDepartments,
            user: rootState.security.user,
            departments: rootState.dealers.departments.departments,
            engineDealer: rootState.dealers.enginedealer.enginedealer,            
            isSyncingDealer: serviceLoading(rootState, [SYNC_DEALER_API_REQUEST]),            
            listingsChanges: rootState.dealers.listing.listings.listingsChanges,
        }
    }, shallowEqual)

    

    const {title, showSyncButton} = React.useMemo(() => {    
        let title =TITLES[location.pathname] as (string | undefined) 
        let showSyncButton = true;
        if (title == undefined)        
        {        
            let patharray = location.pathname.split('/');
            title = patharray[patharray.length-1];
        }        
        if (title == "Google Performance")
            showSyncButton =false;
    
        return {title, showSyncButton};
    }, [location.pathname])

    const engineDealerProps = useSelector((rootState: RootState) => {
        const isRequestingLastSyncDate = serviceLoading(rootState, [GET_LASTSYNCDATE_API_REQUEST]);
        return {
            lastsyncdate: rootState.dealers.enginedealer.lastsyncdate,
            isRequestingLastSyncDate
        }
    }, shallowEqual);

    React.useEffect(()=>{
        if (syncType)
            setShowSyncModal(true);

    },[syncType])

    React.useEffect(()=>{
        if (!isSyncingDealer && triggerPublish) {
            const engineId = getEnginePerPackage(selectedDealer?.lmPackage); 
            dispatch(publishAPI(engineId, selectedDealer?.id, syncType)); 
            setTriggerPublish(false);
        }
    },[isSyncingDealer])

    React.useEffect(()=>{
        if (!isPublishSyncing && isSyncingOrPublishing) {
            setIsSyncingOrPublishing(false);
        }
    },[isPublishSyncing])

    React.useEffect(() => {
        if(selectedDealer && selectedDealer.id)
        {
            dispatch(getLastSyncDateAPI(selectedDealer.id));
        }
    }, [location.pathname,selectedDealer]);

    React.useEffect(() => {

        if (selectedDealer && listingsByDealerId)
        {
            if (listingsByDealerId[selectedDealer.id]) 
            {
                const engine = getEnginePerPackage(selectedDealer?.lmPackage);
                const primaryListing = listingsByDealerId[selectedDealer.id].find(listing => listing.type == ListingType.PRIMARY && listing.engineId==engine);
                if (primaryListing)
                {                    
                    setIsSynced(primaryListing.statusSync=="SYNCED")              
                    if(user &&  user.role==role2)
                    {
                        if (primaryListing.statusSync!="SYNCED")
                            setShowUpsellSetup(true);
                    }                    
                }
            }
        }                 
                            
        if (!isSynced)
            setShowStopModal(false); //Close automatically modal when unsync finished

    }, [selectedDealer, listingsByDealerId]);

    React.useEffect(() => {
        setShowUpsellSetup(anvancedSepUp.current??false);
        setShowUpsellUpgrade(false);
        if(selectedDealer && selectedDealer.id && engineDealer && user){
            if(user.role==role2)
            {
                if(engineDealer.statusConected!='ACTIVE')
                {
                    setShowUpsellUpgrade(true);
                }                
            }
        }        
    }, [selectedDealer,engineDealer,user]);

    React.useEffect(() => {
        if((showUpsellUpgrade || showUpsellSetup) && !hideModals){
            dispatch(blurAppRequest(true));
        }
        else{
            dispatch(blurAppRequest(false));
        }
    }, [showUpsellUpgrade,showUpsellSetup]);

    React.useEffect(() => { 
        let existsPathPart = false;
        for(let i=0;i<VALID_PATHS.length;i++)
        {
            if(location.pathname.includes(VALID_PATHS[i]))
            {
                existsPathPart = true;
                break;
            }
        }
        if(location.pathname!='/' && !VALID_PATHS.includes(location.pathname) && !existsPathPart || (location.pathname!='/' && location.search==''))
        {
            setShowUpsellUpgrade(true);
        } 
        else
        {
            if(showUpsellUpgrade)
            {
                setShowUpsellUpgrade(false);
            }
        }
        if (location.pathname!=="/dealer/advanced") setHideSearch(false);
    }, [location.pathname])
    
    const performanceReportProps = useSelector((rootState: RootState) => {
        const isRequestingInsightsStats = serviceLoading(rootState, [GET_USER_SETTING_API_REQUEST]);
        return {
            sinceDate: rootState.dealers.offerInsights.stats?.sinceDate,
            untilDate: rootState.dealers.offerInsights.stats?.untilDate,
            totalPosts: rootState.dealers.offerInsights.stats?.totalPosts,
            isRequestingInsightsStats
        }
    }, shallowEqual);

    const container = React.createRef<HTMLDivElement>()
    React.useEffect(() => {  
        if (container.current)
            container.current.scrollTop =0;            
        
    },[location.pathname])


    React.useEffect(() => {           
        if (webSiteProvider) {
            changeDocumentHead(webSiteProvider);
        } else {
            changeDocumentHead(DEFAULT_WEBSITE_PROVIDER);
        }
    }, [webSiteProvider?.id]);

    const handleSettingsPanel = () => {
      dispatch(openSettingsPanelAction(!openSettingsPanel))
    }

    const handleAdvanced = (hide: boolean) => {
        if (engineDealer?.statusConected!=='ACTIVE') return;
        if (hide && (selectedDealer?.lmPackage!=="ELITE" || !selectedDealer?.lmPackage)) {
            setShowUpsellUpgradePackage(!showUpsellUpgradePackage);
        } else if (hide && selectedDealer){
            history.push({
                pathname: `/dealer/advanced`,
                search: `?dealer=${selectedDealer.id}`
            });
            setHideSearch(hide);
            setCollapse(true);
        }
    }
    return (
        <HomeContainer>
            <Header>
                <HeaderContainer>
                    {/*<ButtonTooltip tip={props.collapse ? "Expand" : "Collapse"}>
                        <RotateIcon colapse={props.collapse} onClick={() => props.onCollapseClick(!props.collapse)}>
                            <ArrowLeftIcon />
                        </RotateIcon>
                    </ButtonTooltip>*/}
                    {
                        <HeaderIconContainer>
                            {
                                selectedDealer?.industry === "Automotive" ?
                                <DealeronIcon style={{cursor: "pointer" }} onClick={() => {
                                    if (webSiteProvider?.cmsURL)
                                        window.location.href = webSiteProvider.cmsURL;
                                }}/>
                                :
                                <LeadScienceIcon style={{cursor: "pointer" }} onClick={() => {
                                    if (webSiteProvider?.cmsURL)
                                        window.location.href = webSiteProvider.cmsURL;
                                }}/>
                            }
                        </HeaderIconContainer>
                    }                   
                    { !hideSearch && <SearchContainer><DealerSelect /></SearchContainer>} 
                </HeaderContainer>
            </Header>
            <SettingsPanel isSynced={isSynced} handleChangeSync={handleChangeSync} />

            <Content> 
                <SideBar collapse={collapse} onCollapseClick={setCollapse} hideSearch={(hide: boolean) => handleAdvanced(hide)}/>
                <ContentCol>
                        {(showHeader) &&
                        <InfoHeader>
                            <Title>
                                {
                                    title
                                }
                            </Title>
                            <DatesContainer>
                                { !engineDealerProps.isRequestingLastSyncDate && engineDealerProps.lastsyncdate != undefined && engineDealerProps.lastsyncdate != null && title!=='Reviews Widgets' &&

                                    <DatesLastSyncContainer>
                                        <DatesLastSyncText>
                                            Last sync: {formatDate(engineDealerProps.lastsyncdate)}
                                        </DatesLastSyncText>
                                        <DatesInfoIconContainer>
                                            <InfoIcon/>
                                        </DatesInfoIconContainer>
                                        <DatesToolTipContainer>
                                            <DatesToolTipText>
                                                This is the last time any changes/updates
                                                happened in GBP
                                            </DatesToolTipText>
                                        </DatesToolTipContainer>
                                    </DatesLastSyncContainer>                            
                                }

                                {(title=='Google Performance' && !performanceReportProps.isRequestingInsightsStats) &&                        
                                <Calendar performanceReportProps={performanceReportProps} />}   

                                {(title==='Reviews Widgets' && !performanceReportProps.isRequestingInsightsStats) &&                        
                                <ActionButtons/>}        
                                
                                {/*:
                                    <>
                                        {
                                        showSyncButton && engineDealer?.statusConected=="ACTIVE" &&
                                        <ActionSection>
                                            {`SYNC LISTINGS MANAGER WITH GBP`}
                                            <Switch checked={isSynced} onChange={handleChangeSync}/>                                    
                                        </ActionSection>                                                             
                                        }                                
                                        {
                                            user?.role =="DealerUser" && isSynced &&
                                            <TooltTip
                                                renderIcon ={renderIcon}                                        
                                                renderBody={renerToolTipBody}
                                                position={ToolTipDirection.BOTTOM_LEFT}
                                            />
                                        }                                
                                    </>                        
                                */}
                            
                            </DatesContainer>
                        </InfoHeader>}
                        
                        <HomeBody ref={container} top={hideSearch ? 60 : 120}>
                            { !hideModals &&
                                <>
                                    <ModalPush
                                        onSyncConfirmed={() =>  {    
                                            setIsSyncingOrPublishing(true);                                
                                            setTriggerPublish(true);
                                            const engineId = getEnginePerPackage(selectedDealer?.lmPackage); 
                                            dispatch(syncEngineDealerAPI(engineId, selectedDealer!.id));
                                        }}
                                        onCancel={() => {
                                            setSyncType(undefined);
                                            setIsSynced(false)
                                            setShowSyncModal(false)}}
                                        shouldShow={showSyncModal}
                                        onOKClose={() => {
                                            setShowSyncModal(false);
                                            if (publishSyncResult != undefined) {
                                                window.location.reload();
                                            }
                                        }}
                                        isSyncing={isSyncingOrPublishing}
                                        errorMessage={publishSyncResult?.message}
                                        modal={modal()}
                                        package={selectedDealer?.lmPackage}
                                        listingsChanges={listingsChanges}
                                    />
                                    <ModalStart
                                        onStartConfirmed={() =>  {
                                            setShowStartModal(false);          
                                            setShowSyncModal(true);                        
                                        }}
                                        onCancel={() => {
                                            setIsSynced(false)
                                            setShowStartModal(false)}}
                                        shouldShow={showStartModal}
                                        onOKClose={() => {
                                            setShowStartModal(false);
                                        }}
                                        isSyncing={isStopSyncing}
                                        errormessage={syncPublishErrorMessage()}
                                        successmessage={syncPublishSucessMessage()}
                                        />          
                                    <ModalStop
                                        onStopConfirmed={() =>  {
                                            const engineId = getEnginePerPackage(selectedDealer?.lmPackage);
                                            dispatch(unsyncEngineDealerAPI(engineId, selectedDealer!.id));                        
                                            setShowStopModal(false);
                                            window.location.reload();
                                        }}
                                        onCancel={() => {
                                            setIsSynced(true)
                                            setShowStopModal(false)}}
                                        shouldShow={showStopModal}
                                        onOKClose={() => {
                                            setShowStopModal(false);
                                        }}
                                        isSyncing={isStopSyncing}
                                        errormessage={syncPublishErrorMessage()}
                                        successmessage={syncPublishSucessMessage()}
                                        />    
                                    <ModalUpsellUpgrade
                                        shouldShow={showUpsellUpgrade}
                                        dealerId={selectedDealer?.id}
                                        websiteProvider={webSiteProvider ?? DEFAULT_WEBSITE_PROVIDER}
                                    />
                                    <ModalUpsellUpgradePackage
                                        shouldShow={showUpsellUpgradePackage}
                                        dealerId={selectedDealer?.id}
                                        goToChatMeter={isSynced}
                                        showUpsellSetup={()=> { setShowUpsellSetup(true); setShowUpsellUpgradePackage(false);}}
                                        onClose={() => setShowUpsellUpgradePackage(false)}
                                    />
                                    <ModalUpsellSetup
                                        shouldShow={showUpsellSetup}
                                        dealerId={selectedDealer?.id}
                                    />
                                </>
                            }
                            {
                                showStartEliteModal && 
                                <ModalStartElite
                                    showModal={showStartEliteModal}
                                    onCancel={() => {
                                        setIsSynced(false)
                                        setShowStartEliteModal(false)
                                    }}                                
                                    onConfirm={(syncType:any) => {                                        
                                        setShowStartEliteModal(false)       
                                        setSyncType(syncType);
                                        //setShowSyncModal(true);  
                                    }}
                                />                            
                            }
                            <DealerDetail
                                setHideModals={setHideModals}
                            />
                        </HomeBody>
                </ContentCol>
            </Content>
        </HomeContainer>
    )

    function modal(): string {
        if (publishSyncResult != undefined && publishSyncResult?.type == "SUCCESS") {
            if (selectedDealer && selectedDealer.lmPackage && selectedDealer.lmPackage == "ELITE")
                return 'successelite';
            else
                return 'success';
        }
        if (publishSyncResult != undefined && publishSyncResult?.type == "SUCCESSWITHERRORS") {
            return 'partial';
        }
        if (publishSyncResult != undefined && publishSyncResult?.type == "ERROR") {
            if (selectedDealer && selectedDealer.lmPackage && selectedDealer.lmPackage == "ELITE")
                return "notSyncedelite"
            else
                return 'notSynced';
        }
        return '';
    }

    function syncPublishErrorMessage() {
        if (publishSyncResult != undefined && publishSyncResult?.type != "SUCCESS") {
            return 'Error: ' + publishSyncResult?.message;
        }
        return undefined;
    }

    function syncPublishSucessMessage() {
        if (publishSyncResult != undefined && publishSyncResult?.type == "SUCCESS") {
            return publishSyncResult?.message;
        }
        return undefined;
    }

    function handleChangeSync(e)
    {
        if (selectedDealer && user?.role!="DealerUser")
        {
            setIsSynced(e);        
            if (e)
            {
                if (selectedDealer.lmPackage && selectedDealer.lmPackage == "ELITE")
                    setShowStartEliteModal(true)
                else
                    setShowStartModal(true)
            }
            else
                setShowStopModal(true)            
        }
        else
        {
            //setShowUpsellSetup(true)
        }

        
    }



    function formatDate(date?: Date)
    {
        if(!date)
        {
            return '';
        }
        let stringDate : string = new Intl.DateTimeFormat('en-US', {month:'short',day:'numeric',year:'numeric'}).format(new Date(date));
        return stringDate.replace('.','');
    }
}

export default Home;
